import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';

import { reportsReducer } from '../../modules/reports/reports-slice';

import { toursReducer } from '../../modules/tours/tours-slice';
import { basicDashboardReducer } from '../../modules/basic-dashboard/reducers';
import { myStatsApi } from '../../modules/my-stats/my-stats-api';
import { companiesReducer } from '../../modules/companies/companies-slice';
import { companiesApi } from '../../modules/companies/companies-api';
import repoHitList from '../../modules/repo-hit-list/repo-hit-list-reducers';
import { spottedVehiclesReducer } from '../../modules/spotted-vehicles/reducers';
import { caseDetailReducer, casesReducer } from '../../modules/cases/reducers';
import { subscriptionApi } from '../../modules/subscription/subscription-api';
import { usersApi } from '../../modules/users/users-api';
import { onboardingApi } from '../../modules/onboarding/onboarding-api';
import { AuthTypes } from '../actions/auth.actions';
import { basicDashboardAdminReducer } from '../../modules/basic-dashboard-admin/reducers';
import { settingsReducer } from '../../modules/settings/redux/reducers';
import { systemReducer } from '../../modules/system/redux/reducers';
import manualHotCasesReducers from '../../modules/manual-hot-cases/manual-hot-cases-reducers';
import reportReducer from '../../modules/reports/reports-reducers';
// import lprReducer from '../../modules/lpr/reducers';
import spottedNotSecured from '../../modules/spotted-not-secured/spotted-not-secured-reducers';
import { exportSpottedVehicleReportCsvReducer } from '../../modules/spotted-vehicles/spotted-vehicles-reducers';

import { reducer as AuthReducer } from './auth.reducer';
import { reducer as AppReducer } from './app.reducer';
import { notificationsReducer } from '../../modules/notifications/reducers';
import { reducer as ReportsReducer } from './reports.reducer';
import { reducer as GoalsReducer } from './goals.reducer';
import { reducer as TodoListReducer } from './todolist.reducer';
import { reducer as TaskManagementReducer } from './taskmanagement.reducer';
import { reducer as HumanResourcesReducer } from './humanresources.reducer';
import { reducer as ChecklistReducer } from './checklist.reducer';
import { reducer as ShiftsReducer } from './shifts.reducer';
import { reducer as ShiftDetailsReducer } from './shift-details.reducer';
import { reducer as ShiftReducer } from './shift.reducer';
import { reducer as StatsReducer } from './stats.reducer';
import { reducer as ShiftAdminReducer } from './shift-admin.reducer';
import { reducer as StatsCompanyReducer } from './stats-company.reducer';
import { reducer as CompanyReducer } from './company.reducer';
import { loadingCreateEditShiftReducer } from '../../modules/shift-management/hooks/useCreateEditShiftLoading';
import { checklistReducer } from '../../modules/checklists/redux/checklistSlice';
import { shiftLifecycleReducer } from '../../modules/shift-lifecycle/redux/slice';
import { reviewHitsReducer } from '../../modules/lpr/review-hits/redux/reviewHitsSlice';
import { locationReducer } from '../slices/locationSlice';
import { AUTH_SLICE_NAME, authReducer } from '../../modules/auth';

const appReducer = (history) =>
  combineReducers({
    exportSpottedVehiclesCsv: exportSpottedVehicleReportCsvReducer,
    caseDetail: caseDetailReducer,
    cases: casesReducer,
    basicDashboard: basicDashboardReducer,
    basicDashboardAdmin: basicDashboardAdminReducer,
    spottedVehicles: spottedVehiclesReducer,
    router: connectRouter(history),
    auth: AuthReducer,
    [AUTH_SLICE_NAME]: authReducer,
    app: AppReducer,
    notifications: notificationsReducer,
    reports: ReportsReducer,
    goals: GoalsReducer,
    todolist: TodoListReducer,
    taskmanagement: TaskManagementReducer,
    humanresources: HumanResourcesReducer,
    checklist: ChecklistReducer,
    shifts: ShiftsReducer,
    shiftDetails: ShiftDetailsReducer,
    shift: ShiftReducer,
    stats: StatsReducer,
    shiftAdmin: ShiftAdminReducer,
    statsCompany: StatsCompanyReducer,
    dataCompany: CompanyReducer,
    [myStatsApi.reducerPath]: myStatsApi.reducer,
    [subscriptionApi.reducerPath]: subscriptionApi.reducer,
    [usersApi.reducerPath]: usersApi.reducer,
    [onboardingApi.reducerPath]: onboardingApi.reducer,
    [companiesApi.reducerPath]: companiesApi.reducer,
    reportsReducer,
    checklistReducer,
    locationReducer,
    shiftLifecycleReducer,
    reviewHitsReducer,
    // lprReducer,
    toursReducer,
    companiesReducer,
    repoHitList,
    settings: settingsReducer,
    system: systemReducer,
    manualHotCases: manualHotCasesReducers,
    reportReducer,
    spottedNotSecured,
    loadingCreateEditShift: loadingCreateEditShiftReducer,
  });

const reducers = (history) => {
  return (state, action) => {
    /*
      Clear all data in redux store to initial.

      This action is used when user logout and
      accept invite to join company
    */
    if (action.type === AuthTypes.LOGOUT_SUCCESS || action.type === AuthTypes.ACCEPT_INVITE_REQUEST) {
      // The auth session slice survives the reset: its generations must keep increasing across a
      // sign-out, and the auth boundary clears it itself (T094).
      return appReducer(history)({ [AUTH_SLICE_NAME]: state?.[AUTH_SLICE_NAME] }, action);
    }

    return appReducer(history)(state, action);
  };
};

export default reducers;
